import React from 'react';
import PropTypes from 'prop-types';
import './ButtonReturn.css';
import ButtonSquare from './BasicButton';
import returnIcon from './assets/img/back_button_icon.png';
import returnIconDark from './assets/img/back_button_icon_dark.png';



const ButtonReturn = (props) => {
  let buttonStyle = {
    background: `url(${returnIcon}) no-repeat center`,
    width: '45px',
    height: '45px',
  };
  const { link, theme } = props;
  if (theme === 'dark') {
    buttonStyle.background = `url(${returnIconDark}) no-repeat center`;
  } else if (theme === 'light') {
    buttonStyle.background = `url(${returnIcon}) no-repeat center`;
  }
  return (
    <div className="buttonreturn_container">
      <ButtonSquare link={link}>
        <a href="javascript:history.back()">
          <div style={buttonStyle} />
        </a>
      </ButtonSquare>
    </div>
  );
};


ButtonReturn.defaultProps = {
  link: '',
  theme: 'light',
};

ButtonReturn.propTypes = {
  link: PropTypes.string,
  theme: PropTypes.string,
};

export default ButtonReturn;



// WEBPACK FOOTER //
// ./src/components/ButtonSquare/ButtonReturn.jsx